import { memo } from "react";
import { Box, Card, CardContent, Divider, Grid, Typography } from "@mui/material";
import { formatValue } from "components/ui/formatters";
import { SingleValueCardColor } from "constants/index";
import { MultiValuesCardProps } from "helpers/types";
import EditableTextField from "./EditableTextField"; 

const ValueItem = memo(({ item }: { item: MultiValuesCardProps["values"][number] }) => {
  const displayColor = item.color || SingleValueCardColor.PRIMARY;
  const numericValue = typeof item.value === "number" ? item.value : parseFloat(item.value.toString()) || 0;
  const formattedValue = formatValue(numericValue, item.type);

  return (
    <Grid item xs={12} md={item.fullWidthRow ? 12 : 6}>
      <Typography variant="body2" sx={{ mb: 0.5, color: "text.secondary" }}>
        {item.label}:
      </Typography>
      
      <Box display="flex" alignItems="center" gap={1}>
        <EditableTextField
          value={numericValue}
          formattedValue={formattedValue}
          type={item.type}
          displayColor={displayColor}
          onValueChange={item.onValueChange as (val: number) => void}
        />
        {item.action}
      </Box>

    </Grid>
  );
});

const MultiValuesCard = ({
  title,
  values,
  description,
  additionalComponents,
}: MultiValuesCardProps) => {
  return (
    <Card sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center", mt: 2 }}>
      <CardContent sx={{ width: "100%" }}>
        <Typography
          variant="h5"
          sx={{ mb: 2, color: "#ffffff", backgroundColor: "#003057", padding: 1, borderRadius: 1 }}
        >
          {title}
        </Typography>
        
        <Grid container spacing={3}>
          {values.map((item, index) => (
            <ValueItem key={index} item={item} />
          ))}
        </Grid>
        
        {additionalComponents}
        
        {description !== "" && (
          <>
            <Divider sx={{ my: 2 }} />
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {description}
            </Typography>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default MultiValuesCard;
